// src/components/WeekSelector.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WeekSelector.css';

const WeekSelector = ({
    onWeekChange,
    minWeek,
    maxWeek,
    weeks = null,
    weekLabels = {},
    selectedWeek = null,
    disable = false,
    className = "",
    selectClassName = "",
}) => {
    const navigate = useNavigate();

    // Ensure selectedWeek is never null
    selectedWeek = selectedWeek ?? maxWeek - 1;

    const handleChange = (event) => {
        const newWeek = Number(event.target.value);
        navigate(`?week=${newWeek}`);
        onWeekChange(newWeek);
    };

    const availableWeeks =
        weeks ||
        Array.from({ length: maxWeek - minWeek + 1 }, (_, i) => minWeek + i);

    return (
        <div className={`select ${className}`.trim()}>
            <select
                name="league-select"
                id="league-select"
                onChange={handleChange}
                value={selectedWeek}
                disabled={disable}
                className={
                    selectClassName ||
                    `
                        h-full px-3 py-2
                        text-xs font-sans font-bold uppercase tracking-wide
                        bg-surface text-text-muted
                        border border-border rounded-lg
                        hover:text-forest hover:border-forest/40
                        focus:outline-none focus:ring-2 focus:ring-forest/30
                        transition-colors duration-150
                        cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed
                    `
                }
                aria-label="Select week"
            >
                {availableWeeks.map((week) => {
                    return (
                        <option key={week} value={week}>
                            {weekLabels[week] ||
                                weekLabels[String(week)] ||
                                `Week ${week}`}
                        </option>
                    );
                })}
            </select>
            <span className="focus"></span>
        </div>
    );
};

export default WeekSelector;
